import { html, TemplateResult } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { styleMap } from 'lit/directives/style-map.js';
import { Category, CategoryGroup, MegaMenuTemplateProps, MenuItem } from '../../shared/types';
import { environment } from '../../environments/environment';

const renderCoreOption = (
  item: MenuItem,
  idx: number,
  props: MegaMenuTemplateProps
): TemplateResult => {
  const isSelected = props.selectedOption?.title === item.title;
  const id = ['inmobiliario', 'movilidad', 'compras'][idx] ?? `opt-${idx}`;

  return html`
    <li
      id=${id}
      class=${classMap({
        'core-option': true,
        'core-option--active': isSelected,
        'bc-flex': true,
        'bc-direction-column': true,
        'bc-align-items-center': true
      })}
    >
      <div
        class="bc-flex bc-justify-content-space-between bc-align-items-center core-option-btn"
        style=${styleMap({ '--color': props.selectedOption?.brandColor ?? '#000' })}
        @click=${() => props.onCoreSelect(idx, id, 'mobile')}
      >
        <img src="${environment.assetsUrl}/images/${id}.svg" alt=${item.title} />
        <em class="bc-icon">${isSelected ? 'arrow2-up' : 'arrow2-down'}</em>
      </div>
      <ul
        class=${classMap({
          'mobile-categories': true,
          'bc-flex': true,
          'bc-direction-column': true,
          'mobile-categories--active': isSelected
        })}
      >
        ${repeat(
          item.categories,
          i => i.title,
          (item, idx) => renderSubOption(item, idx, props)
        )}
      </ul>
    </li>
  `;
};

const renderSubOption = (
  item: Category,
  idx: number,
  props: MegaMenuTemplateProps
): TemplateResult => {
  const isSelected = props.selectedCategory?.title === item.title;
  return html`
    <li
      id="category-${idx}"
      class=${classMap({
        'category-option': true,
        'category-option--active': isSelected,
        'bc-flex': true,
        'bc-direction-column': true,
        'bc-align-items-center': true
      })}
      @click=${() => {}}
    >
      <div
        class="category-option__content bc-flex bc-justify-content-space-between bc-align-items-center"
        @click=${() => props.onCategorySelect(item)}
      >
        <div class="bc-flex bc-align-items-center bc-gap-2">
          <em class="bc-icon">${item.icon}</em>
          ${item.title}
        </div>
        <em class="bc-icon arrow">${isSelected ? 'arrow2-up' : 'arrow2-down'}</em>
      </div>
      <ul
        class="categories-opts bc-flex bc-direction-column"
        class=${classMap({
          'categories-opts': true,
          'bc-flex': true,
          'bc-direction-column': true,
          'categories-opts--active': isSelected
        })}
      >
        ${repeat(
          item.listOptions,
          i => i.title,
          item => renderCatOption(item, props)
        )}
        <a
          class="more-info bc-flex bc-align-items-center bc-gap-2"
          href="${item.actionButtonInfo.url}"
          target="_blank"
          rel="noopener noreferrer"
          @click=${(e: MouseEvent) => props.onActionButtonClick(e, item.actionButtonInfo, item.title)}
        >
          <span>${item.actionButtonInfo?.title}</span>
          <i class="bc-icon-button bc-icon">arrow-long-right</i>
        </a>
      </ul>
    </li>

    <li></li>
  `;
};
const renderCatOption = (option: CategoryGroup, props: MegaMenuTemplateProps): TemplateResult => {
  return html`
    <li class="category-opt">
      <h3>${option.title}</h3>
      <ul>
        ${repeat(
          option.options ?? [],
          i => i.title,
          item => html`
            <li class="option">
              <a @click=${(e: MouseEvent) => props.onLeafClick(e, item, option.title)} href="${item.url}">${item.title}</a>
            </li>
          `
        )}
      </ul>
    </li>
  `;
};
export const renderMobileContainer = (props: MegaMenuTemplateProps) => {
  return html`
    <ul class="mobile-opts bc-flex bc-direction-column">
      ${repeat(
        props.menuItems,
        i => i.title,
        (item, idx) => renderCoreOption(item, idx, props)
      )}
    </ul>
  `;
};
